import { type FC, type ReactNode, Children } from "react";
import { type ClassNameProp, Grid } from "@huub-web/ui";
import { mergeClasses } from "@huub-web/utils";

import { pentaptychStyle } from "./Pentaptych.css";

export type PentaptychProps = ClassNameProp & {
  children: ReactNode;
};

/**
 * Pentaptych component displays five children in a layout with one large panel on the left
 * and two columns of two panels each on the right.
 */
export const Pentaptych: FC<PentaptychProps> = ({ children, className }) => {
  const childrenArray = Children.toArray(children);

  return (
    <Grid
      className={mergeClasses("pentaptych", pentaptychStyle, className)}
      variant="none"
    >
      {childrenArray[0]}
      {childrenArray[1]}
      {childrenArray[2]}
      {childrenArray[3]}
      {childrenArray[4]}
    </Grid>
  );
};
